import { Table } from '@mantine/core';

type Props = {
  columns: { key: string; label: string }[];
};

export const TableHeader = ({ columns }: Props) => (
  <Table.Thead>
    <Table.Tr>
      {columns.map(({ key, label }) => (
        <Table.Th key={`header ${key}`}>{label}</Table.Th>
      ))}
    </Table.Tr>
  </Table.Thead>
);
